export enum DonorShieldStatus {    
    Off = 0,
    On = 1,
    Pilot = -1
}